import React from "react";
import ItemsFilter from "components/ops-mgmt/common/ItemsFilter";
import { exprParse } from "helpers/ExprEval";

class ExpressionInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.searchRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(expression) {
    if (expression === "") {
      if (this.props.onChange) {
        this.props.onChange(null);
      }
      return;
    }

    try {
      const expr = exprParse(expression.replace(/name/gi, "ori"));

      if (this.props.onChange) {
        this.props.onChange(expr);
      }
    } catch (error) {
      if (this.props.onError) {
        this.props.onError(error);
      }
    }
  }

  render() {
    const { placeholder = "" } = this.props;

    return (
      <div className="text-sm">
        <div className="mb-1 flex flex-wrap items-center gap-1">
          {["name", "price"].map((value) => {
            return (
              <div
                key={value}
                className="rounded border cursor-pointer px-1 text-center text-orange-700 hover:bg-orange-200"
                style={{ minWidth: "1.5rem" }}
                onClick={() => {
                  if (this.searchRef.current) {
                    this.searchRef.current.insertInputValue(value);
                  }
                }}
              >
                {value}
              </div>
            );
          })}
          {["==", ">", "<", ">=", "<="].map((value) => {
            return (
              <div
                key={value}
                className="rounded border cursor-pointer px-1 text-center font-semibold text-teal-700 hover:bg-teal-200"
                style={{ minWidth: "1.5rem" }}
                onClick={() => {
                  this.searchRef.current.insertInputValue(value);
                }}
              >
                {value}
              </div>
            );
          })}
          {["AND", "OR"].map((value) => {
            return (
              <div
                key={value}
                className="rounded border cursor-pointer px-1 text-center font-semibold text-purple-700 hover:bg-purple-200"
                style={{ minWidth: "1.5rem" }}
                onClick={() => {
                  this.searchRef.current.insertInputValue(value);
                }}
              >
                {value}
              </div>
            );
          })}
        </div>

        <ItemsFilter
          ref={this.searchRef}
          placeholder={placeholder}
          handleSearch={this.handleChange}
        ></ItemsFilter>
      </div>
    );
  }
}

export default ExpressionInput;
